import { useLayoutEffect, useRef, useState, useSyncExternalStore } from "react";

let pendingId = null;
const subs = new Set();
const setPending = (id) => { pendingId = id; subs.forEach((f) => f()); };
const subscribe = (f) => { subs.add(f); return () => subs.delete(f); };
const getSnapshot = () => pendingId;

const COLORS = { lock: "#2A9A7A", unlock: "#E0822E" };

/**
 * Confirmation inline (dé)verrouillage : au clic, le bouton est remplacé sur place par
 * « libellé + Confirmer / Annuler ». Un seul bouton en attente à la fois (store global).
 */
export default function LockConfirm({ id, action, label, onConfirm, children }) {
  const pending = useSyncExternalStore(subscribe, getSnapshot) === id;
  const ref = useRef(null);
  const [minWidth, setMinWidth] = useState(0);
  useLayoutEffect(() => { if (!pending && ref.current) setMinWidth(ref.current.getBoundingClientRect().width); }, [pending]);
  if (!pending) return <span ref={ref} className="inline-flex" onClickCapture={(e) => { e.stopPropagation(); e.preventDefault(); setPending(id); }} data-testid={`${id}-trigger`}>{children}</span>;
  return (
    <span className="inline-flex items-center" style={{ gap: 6, minWidth, background: "#141416", border: "0.5px solid #26262b", borderRadius: 8, padding: "3px 4px 3px 10px" }} data-testid={`${id}-confirm`} role="group">
      <span style={{ fontSize: 12, color: "#e8e8ec", whiteSpace: "nowrap" }}>{label}</span>
      <button type="button" onClick={() => { setPending(null); onConfirm(); }} style={{ fontSize: 11.5, fontWeight: 600, padding: "5px 10px", borderRadius: 6, background: COLORS[action], color: "#FFFFFF" }} data-testid={`${id}-confirm-yes`}>Confirmer</button>
      <button type="button" onClick={() => setPending(null)} style={{ fontSize: 11.5, padding: "5px 10px", borderRadius: 6, background: "#1a1a1e", border: "1px solid #26262b", color: "#c8c8cf" }} data-testid={`${id}-confirm-no`}>Annuler</button>
    </span>
  );
}
